<template>
	<div class="home">
		<el-row class="shangbu">
			<el-col :span="16" class="shangbu-left">
				<el-col class="shangbu-left-shang">
					<el-col class="zhaohao" :span="12" id="accountInfo">
						<el-card class="box-card">
							<div class="card-header"></div>
							<div class="card-body" v-loading="zhaohaoloading" element-loading-spinner="el-icon-loading">
								<div class="titleColor textColor">账号信息</div>
								<ul class="content">
									<li>
										<el-row>
											<el-col :span="9">
												<span class="iconfont iconlaba zhaohao-icon"></span>
												尊敬的用户,你好!
											</el-col>
											<el-col :span="15" class="textR">最近登录时间：{{ $moment(accountInfo.lastLogin).format('YYYY-MM-DD HH:mm') }}</el-col>
										</el-row>
									</li>
									<li>
										<span class="iconfont icontime zhaohao-icon"></span>
										有效期至：{{ $moment(accountInfo.custInfo == null ? new Date() : accountInfo.custInfo.dueDate).format('YYYY-MM-DD HH:mm') }}
									</li>
									<li>
										<span class="iconfont iconyuqingshu zhaohao-icon"></span>
										舆情专题数量：{{ accountInfo.keywordCount }}个
									</li>
								</ul>
							</div>
						</el-card>
					</el-col>
					<el-col class="meiti" :span="12">
						<el-card class="box-card" v-loading="meitiloading" element-loading-spinner="el-icon-loading">
							<div class="card-header"></div>
							<div class="card-body">
								<div class="titleColor textColor">
									<el-row class="meiti-header">
										<el-col :span="12">媒体类型</el-col>
										<el-col :span="12" class="textR">
											<span class="curpointer" :class="{ acitve: mediaTypeDays === 1 }" @click.stop="clickMediaTypeInfo(1)">今日</span>
											<span :class="{ acitve: mediaTypeDays === 7 }" @click.stop="clickMediaTypeInfo(7)" class="curpointer">一周</span>
										</el-col>
									</el-row>
								</div>
								<el-row class="content">
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconquanbu meitype-icon"></i>
												全部
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiTypeAll + ''" placement="top" :disabled="meitiTypeAll < 9999">
												<span class="shuzi textColor borderColor">{{ meitiTypeAll > 9999 ? '9999+' : meitiTypeAll }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconxinwen meitype-icon"></i>
												新闻
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType1 + ''" placement="top" :disabled="meitiType1 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType1 > 9999 ? '9999+' : meitiType1 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconweibo meitype-icon"></i>
												微博
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType4 + ''" placement="top" :disabled="meitiType4 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType4 > 9999 ? '9999+' : meitiType4 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconweixin meitype-icon"></i>
												微信
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType9 + ''" placement="top" :disabled="meitiType9 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType9 > 9999 ? '9999+' : meitiType9 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconluntan meitype-icon"></i>
												论坛
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType2 + ''" placement="top" :disabled="meitiType2 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType2 > 9999 ? '9999+' : meitiType2 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconboke meitype-icon"></i>
												博客
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType3 + ''" placement="top" :disabled="meitiType3 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType3 > 9999 ? '9999+' : meitiType3 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconkehuduan meitype-icon"></i>
												客户端
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType8 + ''" placement="top" :disabled="meitiType8 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType8 > 9999 ? '9999+' : meitiType8 }}</span>
											</el-tooltip>
										</div>
									</el-col>
									<el-col :span="6">
										<div>
											<span class="meiti-rediv">
												<i class="iconfont iconshiping meitype-icon"></i>
												视频
											</span>
										</div>
										<div class="mt4">
											<el-tooltip class="item" effect="dark" :content="meitiType10 + ''" placement="top" :disabled="meitiType10 < 9999">
												<span class="shuzi textColor borderColor">{{ meitiType10 > 9999 ? '9999+' : meitiType10 }}</span>
											</el-tooltip>
										</div>
									</el-col>
								</el-row>
							</div>
						</el-card>
					</el-col>
				</el-col>
				<el-col class="shangbu-left-xia">
					<el-col :span="12" class="zuixin">
						<el-card class="box-card" v-loading="zuixinloading" element-loading-spinner="el-icon-loading">
							<div class="card-header"></div>
							<div class="card-body">
								<div class="titleColor textColor">最新舆情</div>
								<el-carousel
									direction="vertical"
									autoplay
									:interval="10000"
									indicator-position="none"
									style="height: 520px;"
									v-show="newlist.length > 0 || newlist2.length > 0"
								>
									<el-carousel-item v-show="newlist.length > 0" class="content" style="height: 520px;">
										<li class="curpointer" v-for="item in newlist" :key="item.id">
											<el-row class="new-row">
												<el-col :span="18" class="title">
													<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
												</el-col>
												<el-col :span="4" class="textR timeinfo">{{ $moment(item.pageTime).format('MM-DD HH:mm') }}</el-col>
											</el-row>
										</li>
									</el-carousel-item>
									<el-carousel-item v-show="newlist2.length > 0" class="content" style="height: 520px;">
										<li class="curpointer" v-for="item in newlist2" :key="item.id">
											<el-row class="new-row">
												<el-col :span="18" class="title">
													<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
												</el-col>
												<el-col :span="4" class="textR timeinfo">{{ $moment(item.pageTime).format('MM-DD HH:mm') }}</el-col>
											</el-row>
										</li>
									</el-carousel-item>
									<el-carousel-item v-show="newlist.length > 0" class="content" style="height: 520px;">
										<li class="curpointer" v-for="item in newlist" :key="item.id">
											<el-row class="new-row">
												<el-col :span="18" class="title">
													<a :href="item.url" target="_blank" class="hovertext">{{ item.title }}</a>
												</el-col>
												<el-col :span="4" class="textR timeinfo">{{ $moment(item.pageTime).format('MM-DD HH:mm') }}</el-col>
											</el-row>
										</li>
									</el-carousel-item>
								</el-carousel>

								<div class="nodata" v-if="newlist.length == 0 && newlist2.length == 0">
									<div class="nodataImg">
										<div class="textC ">
											<i class="iconfont iconwushuju wushuju-icon"></i>
											<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
										</div>
										<div class="textC font14 nodataText">暂无数据！</div>
									</div>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="12" class="mT">
						<el-col class="paihang">
							<el-card class="box-card" v-loading="paihangloading" element-loading-spinner="el-icon-loading">
								<div class="card-header"></div>
								<div class="card-body">
									<div class="titleColor textColor">
										<el-row class="meiti-header">
											<el-col :span="12">专题排行</el-col>
											<el-col :span="12" class="textR">
												<span class="curpointer" :class="{ acitve: keywordRankingDays === 1 }" @click.stop="clickKeywordRankingInfo(1)">今日</span>
												<span :class="{ acitve: keywordRankingDays === 7 }" @click.stop="clickKeywordRankingInfo(7)" class="curpointer">一周</span>
											</el-col>
										</el-row>
									</div>
									<!-- <ul class="content" v-show="keywordRankingInfos.length > 0">
										<li :class="`dot${item.dotindex > 4 ? 4 : item.dotindex}`" v-for="item in keywordRankingInfos" :key="item.dotindex">
											<el-col class="dot">{{ item.dotindex }}</el-col> -->
									<ul class="content" v-show="keywordRankingInfos.length > 0">
										<li
											:class="`dot${item.dotindex > 4 ? 4 : item.dotindex}`"
											v-for="item in keywordRankingInfos"
											v-if="item.dotindex < 6"
											:key="item.dotindex"
										>
											<el-col class="dot">{{ item.dotindex }}</el-col>
											<el-col class="dotline">
												<el-col :span="12" class="textOverOneLine">{{ item.name }}</el-col>
												<el-col :span="12" class="textR">{{ item.value }}</el-col>
											</el-col>
										</li>
									</ul>
									<div class="nodata" v-show="keywordRankingInfos.length == 0">
										<div class="nodataImg">
											<div class="textC ">
												<i class="iconfont iconwushuju wushuju-icon"></i>
												<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
											</div>
											<div class="textC font14 nodataText">暂无数据！</div>
										</div>
									</div>
								</div>
							</el-card>
						</el-col>
						<el-col class="zhanbi">
							<el-card class="box-card" v-loading="zhanbiloading" element-loading-spinner="el-icon-loading">
								<div class="card-header"></div>
								<div class="card-body">
									<div class="titleColor textColor">来源占比</div>
									<div class="bingtu" v-show="zbData.length > 0">
										<el-col :span="17"><div id="bingtu" class="bingtu"></div></el-col>
										<el-col :span="7">
											<ul class="zhanbiInfos">
												<li :class="`dot${item.index}`" v-for="item in zbData" :key="item.id">
													<el-col :span="14" class="textOverOneLine">
														<span class="dot" :style="{ backgroundColor: item.color }"></span>
														<span class="">{{ item.name }}</span>
													</el-col>
													<el-col :span="10" class="textR perNum">{{ item.percent }}</el-col>
												</li>
											</ul>
										</el-col>
									</div>

									<div class="nodata" v-show="zbData.length == 0">
										<div class="nodataImg">
											<div class="textC "><i class="iconfont iconwushuju wushuju-icon"></i></div>
											<div class="textC font14 nodataText">暂无数据！</div>
										</div>
									</div>
								</div>
							</el-card>
						</el-col>
					</el-col>
				</el-col>
			</el-col>
			<el-col :span="8" class="shangbu-right">
				<el-card class="box-card" v-loading="yujingloading" element-loading-spinner="el-icon-loading">
					<div class="card-header"></div>
					<div class="card-body">
						<div class="titleColor textColor shangbu-right-header">
							<el-row class="gengduo">
								<el-col :span="12">预警舆情</el-col>
								<el-col :span="12" class="textR">
									<!-- <span class="gengduoIcon">...</span> -->
									<!-- <span @click.stop="pushEarlyWarning" class="curpointer"><img src="../../assets/img/global/gengduo.png" alt="" /></span> -->
									<span @click.stop="pushEarlyWarning" class="curpointer">
										<i class="iconfont iconchakangengduo iconfont-color hovertext" style="font-size: 20px;"></i>
									</span>
								</el-col>
							</el-row>
						</div>

						<el-carousel
							:loop="true"
							direction="vertical"
							autoplay
							:interval="15000"
							indicator-position="none"
							style="height: 710px;"
							v-show="yujingList.length > 0 || yujingList2.length > 0"
						>
							<el-carousel-item v-show="yujingList.length > 0" class="content" style="height: 710px;">
								<li v-for="item in yujingList" :key="item.id" class="li-early">
									<div class="title textOverOneLine"><a :href="item.url" target="_blank" class="hovertext" v-html="item.titleTag"></a></div>
									<div class="zhaiyao fonttype textOverTwoLine" v-html="item.contentTag"></div>
									<el-row class="fonttype infos">
										<el-col :span="16">
											<i class="iconfont icontime yujing-icon"></i>
											{{ $moment(item.pageTime).format('YYYY-MM-DD HH:mm') }}
										</el-col>
										<el-col :span="8" class="textOverOneLine">
											<i class="iconfont iconlaiyuan yujing-icon"></i>
											来源:{{ item.websiteName }}
										</el-col>
									</el-row>
								</li>
							</el-carousel-item>
							<el-carousel-item v-show="yujingList2.length > 0" class="content" style="height: 710px;">
								<li v-for="item in yujingList2" :key="item.id" class="li-early">
									<div class="title textOverOneLine"><a :href="item.url" target="_blank" class="hovertext" v-html="item.titleTag"></a></div>
									<div class="zhaiyao fonttype textOverTwoLine" v-html="item.contentTag"></div>
									<el-row class="fonttype infos">
										<el-col :span="16">
											<i class="iconfont icontime yujing-icon"></i>
											{{ $moment(item.pageTime).format('YYYY-MM-DD HH:mm') }}
										</el-col>
										<el-col :span="8" class="textOverOneLine">
											<i class="iconfont iconlaiyuan yujing-icon"></i>
											来源:{{ item.websiteName }}
										</el-col>
									</el-row>
								</li>
							</el-carousel-item>
							<el-carousel-item v-show="yujingList.length > 0" class="content" style="height: 710px;">
								<li v-for="item in yujingList" :key="item.id" class="li-early">
									<div class="title textOverOneLine"><a :href="item.url" target="_blank" class="hovertext" v-html="item.titleTag"></a></div>
									<div class="zhaiyao fonttype textOverTwoLine" v-html="item.contentTag"></div>
									<el-row class="fonttype infos">
										<el-col :span="16">
											<!-- <img src="../../assets/img/global/fabiaoshijian.png" alt="" /> -->
											<i class="iconfont icontime yujing-icon"></i>
											{{ $moment(item.pageTime).format('YYYY-MM-DD HH:mm') }}
										</el-col>
										<el-col :span="8" class="textOverOneLine">
											<!-- <img src="../../assets/img/global/dizh.png" alt="" /> -->
											<i class="iconfont iconlaiyuan yujing-icon"></i>
											来源:{{ item.websiteName }}
										</el-col>
									</el-row>
								</li>
							</el-carousel-item>
						</el-carousel>

						<div class="nodata" v-show="yujingList.length == 0 && yujingList2.length == 0">
							<div class="nodataImg">
								<div class="textC ">
									<i class="iconfont iconwushuju wushuju-icon"></i>
									<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
								</div>
								<div class="textC font14 nodataText">暂无数据！</div>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<el-row class="xiabu" :gutter="10">
			<el-col :span="16" class="shuxing">
				<el-card class="box-card" v-loading="shuxingloading" element-loading-spinner="el-icon-loading">
					<div class="card-header"></div>
					<div class="card-body">
						<div class="titleColor textColor">属性占比</div>
						<div class="shuxingtu" v-show="negativeList.length > 0">
							<el-col :span="20"><div id="shuxingtu" class="shuxingtu"></div></el-col>
							<el-col :span="4">
								<div class="info-block mingan">
									<el-col class="pie"></el-col>
									<el-col class="pie-next">
										<p>{{ negativePer }}%</p>
										<p>敏感</p>
									</el-col>
								</div>
								<div class="info-block nomingan">
									<el-col class="pie "></el-col>
									<el-col class="pie-next">
										<p>{{ positivePer }}%</p>
										<p>非敏感</p>
									</el-col>
								</div>
							</el-col>
						</div>

						<div class="nodata" v-show="negativeList.length == 0">
							<div class="nodataImg">
								<div class="textC ">
									<i class="iconfont iconwushuju wushuju-icon"></i>
									<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
								</div>
								<div class="textC font14 nodataText">暂无数据！</div>
							</div>
						</div>
					</div>
					<div>
						<el-col :span="18"><div id="shuxingzhanbi"></div></el-col>
						<el-col :span="6"></el-col>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8" class="ciyun">
				<el-card class="box-card" v-loading="ciyunloading" element-loading-spinner="el-icon-loading">
					<div class="card-header"></div>
					<div class="card-body">
						<div class="titleColor textColor">关键词云</div>
						<div id="chartCloud" ref="chartCloud" v-show="wordCloudInfos.length > 0">
							<word-cloud-chart id="echarts05" :data="wordCloudInfos" ref="wordCloudId" :sizeRange="[12, 20]" />
						</div>

						<div class="nodata" v-show="wordCloudInfos.length == 0">
							<div class="nodataImg">
								<div class="textC ">
									<i class="iconfont iconwushuju wushuju-icon"></i>
									<!-- <img src="../../assets/img/earlyWarning/wsj_07.png" alt="" /> -->
								</div>
								<div class="textC font14 nodataText">暂无数据！</div>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import WordCloudChart from '@/views/components/home/WordCloudChart.vue';
import homeApi from '@/api/home';
export default {
	components: {
		WordCloudChart
	},
	data() {
		return {
			meitiType: '1',
			meitiTypeAll: 0,
			meitiType1: 0,
			meitiType4: 0,
			meitiType9: 0,
			meitiType2: 0,
			meitiType3: 0,
			meitiType8: 0,
			meitiType10: 0,
			paihangType: '1',
			myChart1: null,
			myChart2: null,
			newlist: [],
			newlist2: [],
			yujingList: [],
			yujingList2: [],
			zhanbiInfos: [
				{
					id: '1',
					name: '新闻',
					index: '1',
					percent: '50%'
				},
				{
					id: '2',
					name: '微博',
					index: '2',
					percent: '50%'
				},
				{
					id: '3',
					name: '微信',
					index: '3',
					percent: '50%'
				},
				{
					id: '4',
					name: '论坛',
					index: '4',
					percent: '50%'
				},
				{
					id: '5',
					name: '博客',
					index: '5',
					percent: '50%'
				},
				{
					id: '6',
					name: '客户端',
					index: '6',
					percent: '50%'
				},
				{
					id: '7',
					name: '视频',
					index: '7',
					percent: '50%'
				}
			],
			chatheight: '100',
			zhaohaoloading: false,
			meitiloading: false,
			zuixinloading: false,
			paihangloading: false,
			zhanbiloading: false,
			yujingloading: false,
			shuxingloading: false,
			ciyunloading: false,
			lodingTime: 0,
			accountInfo: {
				custInfo: {}
			},
			mediaTypeDays: 1,
			mediaTypeInfos: [],
			keywordRankingDays: 1,
			keywordRankingInfos: [],
			wordCloudInfos: [],
			mediaTypeSourcePerInfo: [],
			zbData: [],
			shuxinXdata: [],
			shuxinData1: [],
			shuxinData2: [],
			negativeList: [],
			positiveList: [],
			negativePer: 0,
			positivePer: 0,
			timer: null
		};
	},
	created() {
		this.initPage();
	},
	mounted() {
		let that = this;
		this.setBingtu();
		this.setShuxingtu();
		this.setUserinfo();
		this.clickMediaTypeInfo(1);
		this.clickKeywordRankingInfo(1);
		this.setWordCloud();
		this.setMediaTypeSourcePerInfo();
		this.setNewsDataInfo(false);
		this.setNewsDataInfo2();
		this.setPropertyTrendInfo();
		this.setWarningDataInfo(false);
		this.setWarningDataInfo2();

		this.timer = setInterval(function() {
			that.setNewsDataInfo(true); //最新舆情
			///setTimeout(function(){
			that.setNewsDataInfo2(); //最新舆情
			//},1000)

			that.setWarningDataInfo(true); //预警舆情
			// setTimeout(function(){
			that.setWarningDataInfo2(); //预警舆情
			// },1000)
		}, 20000);
	},
	beforeDestroy() {
		if (this.timer) {
			//如果定时器还在运行 或者直接关闭，不用判断
			window.clearInterval(this.timer); //关闭
			this.timer = null;
		}
	},
	methods: {
		togpaihangday(index) {
			this.paihangType = index;
		},
		initPage() {
			//假如是初次进来
			if (this.lodingTime === 0) {
				this.zhaohaoloading = true;
				this.meitiloading = true;
				this.zuixinloading = true;
				this.paihangloading = true;
				this.zhanbiloading = true;
				this.yujingloading = true;
				this.shuxingloading = true;
				this.ciyunloading = true;
				//模拟数据加载完后调用
				setTimeout(() => {}, 1000);
			}
		},
		//来源占比图表
		setBingtu() {
			let that = this;

			// 基于准备好的dom，初始化echarts实例
			if (!document.getElementById('bingtu')) return;
			this.myChart1 = this.$echarts.init(document.getElementById('bingtu'));
			// 绘制图表
			this.myChart1.setOption({
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				// legend: {
				//     orient: 'vertical',
				//     left: 10,
				//     data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
				// },
				series: [
					{
						name: '来源占比',
						type: 'pie',
						radius: ['20%', '50%'],
						// avoidLabelOverlap: false,
						// label: {
						//     show: false,
						//     position: 'center'
						// },
						// emphasis: {
						//     label: {
						//         show: true,
						//         fontSize: '30',
						//         fontWeight: 'bold'
						//     }
						// },
						labelLine: {
							show: true
						},
						label: {
							show: true,
							//formatter: '{d}%'
							formatter: function(data) {
								if (that.zbData != null) {
									for (var zbi = 0; zbi < that.zbData.length; zbi++) {
										if (data.name == that.zbData[zbi].name) {
											that.zbData[zbi].percent = data.percent + '%';
										}
									}
								}
								return data.percent + '%';
							}
						},
						data: this.zbData
					}
				]
			});
			window.addEventListener('resize', () => {
				if (this.myChart1) {
					this.myChart1.resize();
				}
			});
		},
		setShuxingtu() {
			// 基于准备好的dom，初始化echarts实例
			let _this = this;
			let color = ['#f49468', '#67b0f3'];
			let name = ['敏感', '非敏感'];
			let data = [],
				times = [],
				series = [];
			let negativeSum = 0,
				positiveSum = 0;

			if (_this.negativeList != null && _this.negativeList.length > 0) {
				data.push(_this.negativeList.map(s => s.value)); //敏感
				_this.negativeList.forEach(function(item, index) {
					negativeSum = negativeSum + item.value;
				});
				times = _this.negativeList.map(s => _this.$moment(s.title).format('YYYY-MM-DD'));
			}
			if (_this.positiveList != null && _this.positiveList.length > 0) {
				data.push(_this.positiveList.map(s => s.value)); //非敏感
				_this.positiveList.forEach(function(item, index) {
					positiveSum = positiveSum + item.value;
				});
			}
			let positiveNegativeSum = negativeSum + positiveSum;
			_this.negativePer = positiveNegativeSum == 0 || negativeSum == 0 ? 0 : (parseFloat(negativeSum / positiveNegativeSum) * 100).toFixed(2);
			_this.positivePer = positiveNegativeSum == 0 || positiveSum == 0 ? 0 : (parseFloat(positiveSum / positiveNegativeSum) * 100).toFixed(2);

			if (data != null && data.length > 0) {
				data.forEach(function(item, index) {
					series.push({
						name: name[index],
						type: 'line',
						itemStyle: {
							normal: {
								color: color[index]
							}
						},
						smooth: true, //是否平滑曲线显示
						data: item,
						lineStyle: {
							width: 2
						}
					});
				});
			}
			if (!document.getElementById('shuxingtu')) return;
			this.myChart2 = this.$echarts.init(document.getElementById('shuxingtu'));
			// 绘制图表
			this.myChart2.setOption({
				title: {
					//text: '属性占比'
				},
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					left: '3%',
					right: '5%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: times
					// axisLabel: {
					//               interval:0, //坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
					//                rotate:38   //调整数值改变倾斜的幅度（范围-90到90）
					//                }
				},
				yAxis: {
					type: 'value'
				},
				series: series
			});
			window.addEventListener('resize', () => {
				if (this.myChart2) {
					this.myChart2.resize();
				}
			});
		},
		setUserinfo() {
			let that = this;
			homeApi.info({}).then(res => {
				that.accountInfo = res.returnData;
				that.zhaohaoloading = false;
			});
		},
		clickMediaTypeInfo(days) {
			this.mediaTypeDays = days;
			this.setMediaTypeInfo();
		},
		setMediaTypeInfo() {
			let that = this;
			that.meitiloading = true;
			that.meitiTypeAll = 0;
			that.meitiType1 = 0;
			that.meitiType4 = 0;
			that.meitiType9 = 0;
			that.meitiType2 = 0;
			that.meitiType3 = 0;
			that.meitiType8 = 0;
			that.meitiType10 = 0;
			homeApi.mediaType({ analyzeField: 'sourceType', type: 1, days: that.mediaTypeDays }).then(res => {
				that.meitiloading = false;
				if (res.returnCode == '1001') {
					that.mediaTypeInfos = res.returnData.data;
					that.mediaTypeInfos.forEach(item => {
						if (item.title == '1') {
							that.meitiType1 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '4') {
							that.meitiType4 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '9') {
							that.meitiType9 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '2') {
							that.meitiType2 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '3') {
							that.meitiType3 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '8') {
							that.meitiType8 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
						if (item.title == '10') {
							that.meitiType10 = item.value;
							that.meitiTypeAll = that.meitiTypeAll + item.value;
						}
					});
					// if (that.meitiTypeAll > 99999) {
					// 	that.meitiTypeAll = '10万++';
					// }
					// that.meitiTypeAll = 10000;
					// that.meitiType1 = 555555;
					// that.meitiType4 = 66666;
					// that.meitiType9 = 99998;
					// that.meitiType2 = 5555555;
					// that.meitiType3 = 11111;
					// that.meitiType8 = 888;
					// that.meitiType10 = 555;
				}
			});
		},
		clickKeywordRankingInfo(days) {
			this.keywordRankingDays = days;
			this.setKeywordRankingInfo();
		},
		setKeywordRankingInfo() {
			let that = this;
			that.paihangloading = true;
			homeApi.topicRanking({ days: that.keywordRankingDays }).then(res => {
				that.paihangloading = false;
				if (res.returnCode == '1001') {
					let rests = res.returnData.data;
					rests.sort((a, b) => {
						return Number(b.value) - Number(a.value);
					});
					for (var i = 0; i < rests.length; i++) {
						rests[i].dotindex = i + 1;
					}
					that.keywordRankingInfos = rests;
				}
			});
		},
		setWordCloud() {
			let that = this;
			that.ciyunloading = true;
			homeApi.wordCloud({ days: 24, pageNo: 1, pageSize: 30 }).then(res => {
				that.ciyunloading = false;
				if (res.returnCode == '1001') {
					let rst = res.returnData;
					if (rst.titleWords) {
						let data = rst.titleWords.map(s => {
							return { name: s.title, value: s.value };
						});
						that.wordCloudInfos = data;
						setTimeout(() => {
							if (that.$refs.wordCloudId) {
								that.$refs.wordCloudId.initChart();
								that.$refs.wordCloudId.resizeW();
							}
						}, 200);
					}
				}
			});
		},
		setMediaTypeSourcePerInfo() {
			let that = this;
			that.zhanbiloading = true;
			that.zbData = [];
			homeApi.mediaType({ analyzeField: 'sourceType', type: 2, days: 7 }).then(res => {
				that.zhanbiloading = false;
				if (res.returnCode == '1001') {
					let resdata = res.returnData;
					for (var i = 0; i < resdata.length; i++) {
						let resobj = {
							value: resdata[i].value,
							name: resdata[i].key,
							itemStyle: {
								color: resdata[i].color
							},
							color: resdata[i].color
						};
						that.zbData.push(resobj);
					}
					that.setBingtu();
					setTimeout(() => {
						that.myChart1.resize();
					}, 200);
				}
			});
		},
		setNewsDataInfo(flag) {
			let that = this;
			if (!flag) {
				that.zuixinloading = true;
			}
			homeApi.newsData({ days: 0, pageNo: 1, pageSize: 15, sort: 3 }).then(res => {
				that.zuixinloading = false;
				if (res.returnCode == '1001') {
					that.newlist = res.returnData.data;
				}
			});
		},
		setNewsDataInfo2() {
			let that = this;
			homeApi.newsData({ days: 0, pageNo: 2, pageSize: 15, sort: 3 }).then(res => {
				if (res.returnCode == '1001') {
					let rest = res.returnData.data;
					if (rest.length == 0) {
						that.newlist2 = that.newlist;
					} else {
						that.newlist2 = rest;
					}
				}
			});
		},
		setPropertyTrendInfo() {
			let that = this;
			that.shuxingloading = true;
			homeApi.propertyTrend({ days: 7, interval: '1d', pageNo: 1, pageSize: 100 }).then(res => {
				that.shuxingloading = false;
				if (res.returnCode == '1001') {
					that.negativeList = res.returnData.negative;
					that.positiveList = res.returnData.positive;
					that.setShuxingtu();
					setTimeout(() => {
						that.myChart2.resize();
					}, 200);
				}
			});
		},
		setWarningDataInfo(flag) {
			let that = this;
			// that.yujingList = [];
			if (!flag) {
				that.yujingloading = true;
			}
			homeApi.warningData({ days: 0, pageNo: 1, pageSize: 6 }).then(res => {
				that.yujingloading = false;
				if (res.returnCode == '1001') {
					that.yujingList = res.returnData.data;
					that.yujingList.forEach(item => {
						item.contentTag = this.$utils.handleText(item.contentTag);
						item.titleTag = this.$utils.handleText(item.titleTag);
						if (item.contentTag == undefined) {
							item.contentTag = item.content;
						}
						if (item.titleTag == undefined) {
							item.titleTag = item.title;
						}
					});
				}
			});
		},
		setWarningDataInfo2() {
			let that = this;
			homeApi.warningData({ days: 0, pageNo: 2, pageSize: 6 }).then(res => {
				if (res.returnCode == '1001') {
					let rest = res.returnData.data;
					if (rest.length == 0) {
						that.yujingList2 = that.yujingList;
					} else {
						that.yujingList2 = rest;
						that.yujingList2.forEach(item => {
							item.contentTag = this.$utils.handleText(item.contentTag);
							item.titleTag = this.$utils.handleText(item.titleTag);
							if (item.contentTag == undefined) {
								item.contentTag = item.content;
							}
							if (item.titleTag == undefined) {
								item.titleTag = item.title;
							}
						});
					}
				}
			});
		},
		//跳转到预警舆情
		pushEarlyWarning() {
			this.$router.push({ path: '/earlyWarning/earlyWarning', query: { isPush: '1' } });
		}
	}
};
</script>

<style lang="less">
@import '../../assets/css/page/home.less';
#accountInfo .content {
	color: #333;
}
</style>
